import { createFileRoute } from "@tanstack/react-router";
import ShieldIcon from "lucide-react/dist/esm/icons/shield";
import ClockIcon from "lucide-react/dist/esm/icons/clock";

export const Route = createFileRoute("/_dashboard/$datasetSlug/compliance")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="relative flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        {/* Logo/Brand Section */}
        <div className="space-y-4">
          <div className="flex justify-center">
            <div className="rounded-full border border-border bg-card p-4 shadow-lg">
              <ShieldIcon className="h-12 w-12 text-foreground" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground">Compliance</h1>
        </div>

        {/* Coming Soon Section */}
        <div className="space-y-4">
          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <ClockIcon className="h-5 w-5" />
            <span className="text-lg font-medium">Coming Soon</span>
          </div>
          <p className="leading-relaxed text-muted-foreground">
            We're building something amazing to help you stay compliant and secure.
          </p>
        </div>
      </div>
    </div>
  );
}
